export default "__VITE_ASSET__DwM4xdTQ__"